import { NotificationDispatch } from '@tryhackme/thm-ui-components';

import { useTrackEventMutation } from 'src/common/slices';

import { useCreateStripeSubscriptionCheckoutMutation } from './use-stripe-subscription-checkout.slice';
import type { StripeSubscriptionPayload } from './use-stripe-subscription-checkout.types';

// TODO: STRIPE-V2: Move types
//TODO: STRIPE-V2: Move the utility functions

interface ErrorWithData {
  data?: { message?: string };
}

const isErrorWithData = (error: unknown): error is ErrorWithData => {
  return typeof error === 'object' && error !== null && 'data' in error;
};

export const useStripeSubscriptionCheckout = (): {
  isLoading: boolean;
  openCheckout: (payload: StripeSubscriptionPayload) => Promise<void>;
} => {
  const [trackEvent] = useTrackEventMutation();

  const [createStripeSubscriptionCheckout, { isLoading }] = useCreateStripeSubscriptionCheckoutMutation();

  const openCheckout = async (payload: StripeSubscriptionPayload) => {
    trackEvent({ event: 'stripe-checkout-open' });

    try {
      const response = await createStripeSubscriptionCheckout({
        planType: payload.planType,
        interval: payload.interval,
        campaign: payload.campaign,
      }).unwrap();

      // Redirect to Stripe's checkout page
      window.location.href = response.checkoutUrl;
    } catch (error: unknown) {
      const errorMessage = isErrorWithData(error) ? error.data?.message : 'Something went wrong';

      // NOTE: how should we handle this?
      NotificationDispatch('error', 'Something went wrong, please try again later');

      trackEvent({
        event: 'stripe-checkout-error',
        properties: { error: errorMessage },
      });
    }
  };

  return { isLoading, openCheckout };
};
